import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteVisitImageAction } from '../../../../redux/actions/visitImagesActions';
import Button from '../../../shared/buttons/Button';
import Modal from '../../../shared/modal/Modal';

const DeleteVisitImageModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { vin, id } = useSelector((state) => state.visit?.visit);
  const visitImage = useSelector((state) => state.visitImages?.visitImage);

  const onSubmit = async () => {
    setLoading(true);
    await dispatch(deleteVisitImageAction(vin, id, visitImage.id));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Видалення фото візиту'}
      loading={loading}
      onClose={onModalClose}
      body={'Ви дійсно бажаєте видалити це фото візиту?'}
      actionButton={<Button onClick={onSubmit} disabled={loading} variant={'primary'} children={'Видалити'} />}
    />
  );
};

export default DeleteVisitImageModal;
